import Marionette from 'backbone.marionette';
import CategoryListItemView from './category_list_itemview';
export default Marionette.CollectionView.extend({
  childView: CategoryListItemView,
  className: 'row gx-3 gy-3 row-cols-2 row-cols-sm-3'
});